// Where a new account first came from (2 Nov 2026), for the admin dashboard's sign-ups by source, as greeksoup.ai
// keeps it. At the start of a visit the site notes the referring site (a host only) or the link's utm_source, and
// the first page (a path only), in sessionStorage, which ends with the tab. When an account made in the last day
// is signed in, that note is sent once to the worker (cloudflare/admin.mjs handleFirstSource), which keeps only
// the first answer per account. Nothing else is noted, and nothing is sent for an older account.
const KEY = "sn-first-visit", SENT = "sn-first-sent";

export function noteFirstVisit() {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const u = new URL(location.href), tag = (u.searchParams.get("utm_source") || "").toLowerCase().replace(/[^a-z0-9._-]/g, "").slice(0, 60);
    let host = ""; try { host = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : ""; } catch { host = ""; }
    if (/^(www\.)?shikshannivesh\.com$/.test(host)) host = "";   // a page of this site opened in a new tab (ai. is the newsletter)
    // the worker takes a plain path only; anything else in it (an encoded letter, a ~) is left out
    const landing = ("/" + u.pathname.replace(/[^a-z0-9._/-]/gi, "").replace(/^\/+/, "")).slice(0, 200);
    sessionStorage.setItem(KEY, JSON.stringify({ source: tag ? "utm:" + tag : host, landing }));
  } catch { /* storage refused: nothing noted */ }
}

export function sendFirstSource(token: string, createdAt: string | undefined) {
  try {
    if (!token || !createdAt || Date.now() - Date.parse(createdAt) > 86400000 || sessionStorage.getItem(SENT)) return;
    const note = sessionStorage.getItem(KEY);
    if (!note) return;
    // marked sent only once the worker has it, so a failed send is tried again on the next sign-in event
    fetch("/api/data/first-source", { method: "POST", headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, body: note })
      .then((r) => { if (r.ok || r.status === 400) sessionStorage.setItem(SENT, "1"); }).catch(() => {});
  } catch { /* storage refused: nothing sent */ }
}
